const version1 = "v1";

export const API_ENDPOINTS = {
  MY_STORE: `${version1}/customer/stores/my-stores?`,
  MY_DEALS: `${version1}/customer/campaigns/hot-campaigns?enforce_age_restrictions=1`,
  MY_MFG: `${version1}/customer/manufacturers`,
  TOP_LEADERBOARD: `${version1}/customer/rank-info`,
  USER_INFO: `${version1}/customer/details`,
  LOGIN: `${version1}/customer/auth/login`,
  VERIFY_LICENSE: `${version1}/customer/auth/verify-dl`,
  FRIENDS: `${version1}/customer/friend-list`,
  FRIENDS_PAGINATION(page, per_page, friendId = "") {
    if (friendId.length > 0) {
      return `${version1}/customer/friend-list/${friendId}?page=${page}&per_page=${per_page}`;
    }
    return `${version1}/customer/friend-list?page=${page}&per_page=${per_page}`;
  },
  STORE_DETAILS(id) {
    return `${version1}/customer/stores/${id}/get`;
  },
  PROFILE_UPDATE: `${version1}/customer/profile-update`,
  AVATARS: `${version1}/customer/avatars`,
  STORE_OFFER_COUPONS(id) {
    return `${version1}/customer/stores/${id}/altria-deals`;
  },
  STORE_OFFER_THIRDPARTY_COUPONS(id) {
    return `${version1}/customer/stores/${id}/manufacturer-promotion`;
  },
  STORE_OFFER_IN_APP_PROMOTION(id) {
    return `${version1}/customer/stores/${id}/in-app-promotions`;
  },
  TEAM_LEVEL(id) {
    return `${version1}/customer/stores/${id}/team-levels`;
  },
  LEADER_BOARD: `${version1}/customer/rank-info`,
  TEAM_ALL(id) {
    return `${version1}/customer/stores/${id}/all-team`;
  },
  LEADER_BOARD_SEND_FRIEND_REQUEST(id) {
    return `${version1}/customer/${id}/add-friend`;
  },
  USER_INFO_BY_ID(id) {
    return `${version1}/customer/details/${id}`;
  },
  BLOCK_USER(id) {
    return `${version1}/customer/${id}/block`;
  },
  STORE_DEALS(storeid, param = {}) {
    return `${version1}/customer/stores/${storeid}/campaigns?${
      Object.keys(param).length > 0
        ? new URLSearchParams(param).toString()
        : "enforce_age_restrictions=1"
    }`;
  },
  ADD_FEEDBACK(storeid) {
    return `${version1}/customer/stores/${storeid}/add-feedback`;
  },
  MFG_DEALS(manufacturerid) {
    return `${version1}/customer/manufacturers/${manufacturerid}/campaigns?enforce_age_restrictions=1`;
  },
  MFG_DETAILS(manufacturerid) {
    return `${version1}/customer/manufacturers/${manufacturerid}/get`;
  },
  FIND_MFG_DETAILS(manufacturerid) {
    return `${version1}/customer/manufacturers/${manufacturerid}/view`;
  },
  FRIEND_STORES(friendId) {
    return `${version1}/customer/stores/by-customer/${friendId}?enforce_age_restrictions=1`;
  },
  FRIEND_CAMPAIGNS(friendId) {
    return `${version1}/customer/campaigns/customer/${friendId}`;
  },
  FRIEND_FRIENDS(friendId) {
    return `${version1}/customer/friend-list/${friendId}`;
  },
  FRIEND_EARNING_HISTORY(friendId, perPage = 25, page = 1) {
    return `${version1}/customer/earning-history?customer_id=${friendId}&per_page=${perPage}&page=${page}`;
  },
  FRIEND_UNFRIEND(friendId) {
    return `${version1}/customer/${friendId}/remove-friend`;
  },
  ALLOWED_STORES(friendId, enforce_age_restrictions = 1) {
    return `${version1}/customer/${friendId}/allowed-stores?enforce_age_restrictions=${enforce_age_restrictions}`;
  },
  MY_ALLOWED_STORES(friendId, enforce_age_restrictions = 1) {
    return `${version1}/customer/${friendId}/my-allowed-stores?enforce_age_restrictions=${enforce_age_restrictions}`;
  },
  SEND_TEAM_REQUEST(friendId, storeId, enforce_age_restrictions = 1) {
    return `${version1}/customer/${friendId}/send-team-request?store_id=${storeId}&enforce_age_restrictions=${enforce_age_restrictions}`;
  },
  FIND_MFG: `${version1}/customer/manufacturers/find-manufacturers`,
  FIND_MFG: `${version1}/customer/manufacturers/find-manufacturers?enforce_age_restrictions=1`,
  EARNING_HISTORY(campaign_id, page, per_page) {
    return `${version1}/customer/earning-history?campaign_id=${campaign_id}&page=${page}&per_page=${per_page}`;
  },
  FIND_STORES: `${version1}/customer/stores/available?`,
  JOIN_STORE(storeid) {
    return `${version1}/customer/stores/${storeid}/register`;
  },
  STORE_INTERESTS(storeid) {
    return `${version1}/customer/interests?store_id=${storeid}&acc=${storeid}`;
  },
  STORE_PREFS(storeid) {
    return `${version1}/customer/stores/${storeid}/update-prefs`;
  },
  COUPONS_LIST(params) {
    return `${version1}/customer/coupons${params}`;
  },
  MFG_PREFS(manufacturerid) {
    return `${version1}/customer/manufacturers/${manufacturerid}/update-prefs`;
  },
  STORE_LISTING: `${version1}/customer/stores`,
  SWAGSHOP_STORE_PRODUCTS: `${version1}/customer/swag-shop/products`,
  SWAGSHOP_MFG_PRODUCTS: `${version1}/customer/manufacturer/swag-shop/products`,
  CUSTOMER_FEEDBACK: `${version1}/customer/add-feedback`,
  NOTIFICATION(page, per_page) {
    return `${version1}/customer/news-updates?page=${page}&per_page=${per_page}`;
  },
  CAMPAIGNS_DETAILS(dealid) {
    return `${version1}/customer/campaigns/${dealid}/get`;
  },
  CHANGE_PASSWORD: `${version1}/customer/auth/change-password`,
  MESSAGES(page, per_page) {
    return `${version1}/customer/messages?page=${page}&per_page=${per_page}`;
  },
  CHAT_MESSAGES(id, page, per_page) {
    return `${version1}/customer/messages/${id}/view?page=${page}&per_page=${per_page}`;
  },
  CHAT_MESSAGES_UNREAD(id) {
    return `${version1}/customer/messages/${id}/unread`;
  },
  SEND_MSG(id) {
    return `${version1}/customer/messages/${id}/reply`;
  },
  TOGGLE_NOTIFICATION_MSG(id) {
    return `${version1}/customer/messages/${id}/toggle-notifications`;
  },
  CHANGE_GROUP_NAME_MSG(id) {
    return `${version1}/customer/messages/${id}/change-name`;
  },
  GET_GROUP_DETAILS(id) {
    return `${version1}/customer/messages/${id}/get`;
  },
  ADD_MEMBER_GROUP(id) {
    return `${version1}/customer/messages/${id}/add-member`;
  },
  LEAVE_GROUP(id) {
    return `${version1}/customer/messages/${id}/leave`;
  },
  GROUP_CREATE: `${version1}/customer/messages/create`,
  FIND_GROUP: `${version1}/customer/messages/find-group`,
  ADD_FRIENDS_GROUP_LIST(page, per_page) {
    return `${version1}/customer/friend-list?type=friends&page=${page}&per_page=${per_page}`;
  },
  CUSTOMER_DEALS: `${version1}/customer/campaigns?enforce_age_restrictions=1&sortBy=new`,
  ADD_STORE_TO_WISHLIST: `${version1}/customer/swag-shop/wishlist/add-item`,
  REMOVE_STORE_FROM_WISHLIST: `${version1}/customer/swag-shop/wishlist/remove-item`,
  ADD_MFG_TO_WISHLIST: `${version1}/customer/manufacturer/swag-shop/wishlist/add-item`,
  REMOVE_MFG_FROM_WISHLIST: `${version1}/customer/manufacturer/swag-shop/wishlist/remove-item`,
  PRODUCT_DETAIL(id) {
    return `${version1}/customer/swag-shop/products/${id}/get`;
  },
  MFG_PRODUCT_DETAIL(id) {
    return `${version1}/customer/manufacturer/swag-shop/products/${id}/get`;
  },
  PRODUCT_ATTRIBUTES(id) {
    return `${version1}/customer/swag-shop/products/${id}/attributes`;
  },
  MFG_PRODUCT_ATTRIBUTES(id) {
    return `${version1}/customer/manufacturer/swag-shop/products/${id}/attributes`;
  },
  PRODUCT_REVIEWS(id) {
    return `${version1}/customer/swag-shop/products/${id}/reviews`;
  },
  MFG_PRODUCT_REVIEWS(id) {
    return `${version1}/customer/manufacturer/swag-shop/products/${id}/reviews`;
  },
  PRODUCT_DETAIL_ADD_REVIEW(id) {
    return `${version1}/customer/swag-shop/products/${id}/add-review`;
  },
  MFG_PRODUCT_DETAIL_ADD_REVIEW(id) {
    return `${version1}/customer/manufacturer/swag-shop/products/${id}/add-review`;
  },
  SWAG_SHOP_FILTER_CATEGORIES: `${version1}/customer/swag-shop/categories`,
  SWAG_SHOP_MFG_FILTER_CATEGORIES: `${version1}/customer/manufacturer/swag-shop/categories`,
  SWAG_SHOP_FILTER_ALL_CATEGORIES: `${version1}/customer/swag-shop/all-categories`,
  SWAG_SHOP_FILTER_TAGS: `${version1}/customer/swag-shop/tags`,
  SWAG_SHOP_MFG_FILTER_TAGS: `${version1}/customer/manufacturer/swag-shop/tags`,
  RECEIPTS(page, per_page) {
    return `${version1}/customer/receipts?page=${page}&per_page=${per_page}`;
  },
  RECEIPTS_WEB(page, per_page, extraparam) {
    return `${version1}/customer/receipts/all?page=${page}&per_page=${per_page}${extraparam}`;
  },
  RECEIPT_IMAGE(id) {
    return `${version1}/customer/receipts/${id}/image`;
  },
  RECEIPT_HIDE(id) {
    return `${version1}/customer/receipts/${id}/hide`;
  },
  LOTTERY: `${version1}/customer/lottery-purchases`,
  SET_LOTTERY_STATUS: `${version1}/customer/set-lotto-status`,
  GET_FRIEND_REQUESTS: `${version1}/customer/friend-requests`,
  ACCEPT_FRIEND_REQUEST(id) {
    return `${version1}/customer/friend-requests/${id}/accept`;
  },
  DENY_FRIEND_REQUEST(id) {
    return `${version1}/customer/friend-requests/${id}/deny`;
  },
  CANCEL_FRIEND_REQUEST(id) {
    return `${version1}/customer/friend-requests/${id}/cancel`;
  },
  GET_TEAM_REQUESTS: `${version1}/customer/team-requests`,
  ACCEPT_TEAM_REQUEST(id) {
    return `${version1}/customer/team-requests/${id}/accept`;
  },
  DENY_TEAM_REQUEST(id) {
    return `${version1}/customer/team-requests/${id}/deny`;
  },
  CANCEL_TEAM_REQUEST(id) {
    return `${version1}/customer/team-requests/${id}/cancel`;
  },
  COMPLETE_DEALS(page, per_page) {
    return `${version1}/customer/campaigns/completed?page=${page}&per_page=${per_page}`;
  },
  SHIPPING_ADDRESS: `${version1}/customer/addresses`,
  REMOVE_ADDRESS(id) {
    return `${version1}/customer/addresses/${id}/remove`;
  },
  UPDATE_ADDRESS(id) {
    return `${version1}/customer/addresses/${id}/update`;
  },
  CREATE_ADDRESS: `${version1}/customer/addresses/create`,
  GET_CONSENT_TOPICS: `${version1}/customer/get-consent-topics`,
  SAVE_CONSENT_PREF: `${version1}/customer/save-consent-preferences`,
  STORE_LOCATIONS(id) {
    return `${version1}/customer/stores/${id}/locations`;
  },
  MFG_LOCATIONS(id) {
    return `${version1}/customer/manufacturers/${id}/locations`;
  },
  STORE_REMOVE(id) {
    return `${version1}/customer/stores/${id}/remove`;
  },
  BLOCKED_LIST: `${version1}/customer/block-list`,
  UNBLOCKED_FRIEND(id) {
    return `${version1}/customer/${id}/unblock`;
  },
  DELETE_AC: `${version1}/customer/delete-account`,
  DELETE_AC_EXIT_QUESTION: `${version1}/customer/get-exit-questions`,
  SAVE_EXIT_QUESTION: `${version1}/customer/save-exit-questions`,
  JOIN_TEAM(id) {
    return `${version1}/customer/${id}/join-team`;
  },
  TEAM_WITH_LEVEL(page, per_page, id, team_member_id, level_no) {
    return `${version1}/customer/stores/${id}/team-with-level?page=${page}&per_page=${per_page}&team_member_id=${team_member_id}&level_no=${level_no}`;
  },
  ADD_LOYALTY_CARD: `${version1}/customer/cards/add-card`,
  GET_LOYALTY_CARDS: `${version1}/customer/cards`,
  REMOVE_LOYALTY_CARD(id) {
    return `${version1}/customer/cards/${id}/remove`;
  },
  EARNING_HISTORY_STORE(storeid, page, per_page) {
    return `${version1}/customer/earning-history?store_id=${storeid}&page=${page}&per_page=${per_page}`;
  },
  EARNING_HISTORY_MFG(mfgid, page, per_page, campaignid = "") {
    if (campaignid) {
      return `${version1}/customer/manufacturers/earning-history?manufacturer_id=${mfgid}&page=${page}&per_page=${per_page}&campaign_id=${campaignid}`;
    } else {
      return `${version1}/customer/manufacturers/earning-history?manufacturer_id=${mfgid}&page=${page}&per_page=${per_page}`;
    }
  },
  GIFT_RECEIVED: `${version1}/customer/gifts/received`,
  GIFT_SENT: `${version1}/customer/gifts/sent`,
  GIFT_REDEEMED: `${version1}/customer/gifts/redeemed`,
  FRIEND_SEARCH: `${version1}/customer/full-search`,
  STORE_PURCHASES: `${version1}/customer/swag-shop/purchases`,
  DIGITAL_PURCHASES: `${version1}/customer/swag-shop/purchases/digital-coupon/history`,
  MFG_PURCHASES: `${version1}/customer/manufacturer/swag-shop/purchases`,
  STORE_PURCHASE_DETAIL(id) {
    return `${version1}/customer/swag-shop/purchases/${id}/get`;
  },
  MFG_PURCHASE_DETAIL(id) {
    return `${version1}/customer/manufacturer/swag-shop/purchases/${id}/get`;
  },
  STORE_CONFIRM_PURCHASE(id) {
    return `${version1}/customer/swag-shop/products/${id}/purchase`;
  },
  MFG_CONFIRM_PURCHASE(id) {
    return `${version1}/customer/manufacturer/swag-shop/products/${id}/purchase`;
  },
  GET_USER_BALANCE: `${version1}/customer/balances`,
  MFG_USER_BALANCE: `${version1}/customer/manufacturer/balances`,
  GIFT_DETAIL(id) {
    return `${version1}/customer/gifts/${id}/get`;
  },
  MFG_GIFT_DETAIL(id) {
    return `${version1}/customer/manufacturer/gifts/${id}/get`;
  },
  MFG_GIFT_RECEIVED: `${version1}/customer/manufacturer/gifts/received`,
  MFG_GIFT_SENT: `${version1}/customer/manufacturer/gifts/sent`,
  MFG_GIFT_REDEEMED: `${version1}/customer/manufacturer/gifts/redeemed`,
  GIFT_ACCEPT(id) {
    return `${version1}/customer/gifts/${id}/accept`;
  },
  GIFT_DECLINE(id) {
    return `${version1}/customer/gifts/${id}/decline`;
  },
  MFG_GIFT_ACCEPT(id) {
    return `${version1}/customer/manufacturer/gifts/${id}/accept`;
  },
  MFG_GIFT_DECLINE(id) {
    return `${version1}/customer/manufacturer/gifts/${id}/decline`;
  },
  VERIFY_EMAIL: `${version1}/customer/auth/verify-email`,
  VERIFY_PHONE: `${version1}/customer/auth/verify-phone`,
  VERIFY_USERNAME: `${version1}/customer/auth/verify-username`,
  VERIFY_OWNERSHIP_BY_EMAIL_OR_PHONE: `${version1}/customer/auth/verify-ownership/phone-or-email`,
  USER_ACCEPT_CONSENT(id) {
    return `${version1}/customer/accept-consent/${id}`;
  },
  GET_CONSENT_CONTENT: `${version1}/customer/get-consent-content`,
  POLL_UPDATE: `${version1}/customer/poll-update`,
  SEND_RESET_PASSWORD: `${version1}/customer/auth/send-password-reset`,
  VERIFY_RESET_PASSWORD_CODE: `${version1}/customer/auth/verify-code`,
  RESET_PASSWORD: `${version1}/customer/auth/password-reset`,
  LOGOUT: `${version1}/customer/logout`,
  FIND_STORE_TAG_LIST: `${version1}/customer/stores/get-filter-tags-list`,
  FIND_STORE_DISTANCE_LIST: `${version1}/customer/stores/get-distance-filter-list`,

  ALL_EAIV_STATUS(id) {
    return `${version1}/customer/stores/${id}/all-eaiv-status`;
  },
  SURVAY_OPTION(id) {
    return `${version1}/customer/stores/${id}/survey-options`;
  },
  POST_SURVAY(id) {
    return `${version1}/customer/stores/${id}/post-survey`;
  },
  ALTRIA_CONSENT_STATUS(id) {
    return `${version1}/customer/stores/${id}/consent-status?acc=${id}`;
  },
  SAVE_CONSENT(id) {
    return `${version1}/customer/stores/${id}/save-consent`;
  },
  POST_SAVE_EAIV_STATUS(id) {
    return `${version1}/customer/stores/${id}/save-skip-status`;
  },
  POST_SAVE_NOTIFICATION_STATUS(id) {
    return `${version1}/customer/stores/${id}/disable-notification`;
  },
  EAIV_COMPLETE_STATUS(id) {
    return `${version1}/customer/stores/${id}/eaiv-completed`;
  },
  VERIFY_OWNERSHIP: `${version1}/customer/auth/verify-ownership`,
  REGISTER_FROM_IDENTITY: `${version1}/customer/auth/register-from-identity`,
  EARNING_HISTORY_USER(page, per_page) {
    return `${version1}/customer/earning-history?page=${page}&per_page=${per_page}`;
  },
  GET_FILTER_LIST_DEAL(type) {
    return `${version1}/customer/campaigns/get-filter-list?campaign-type=${type}`;
  },
  ALL_DEALS(param) {
    return `${version1}/customer/campaigns/all-campaigns${param}`;
  },
  MFG_COUPONS(param) {
    return `${version1}/customer/manufacturers/${param}/coupons`;
  },
  GET_STORE_REVIEW(storeID) {
    return `${version1}/customer/stores/${storeID}/reviews`;
  },
  STORE_BALANCE(id) {
    return `${version1}/customer/balances?store_id=${id}&acc=${id}`;
  },
  GET_STORE_REVIEW_DETAIL(storeID, reviewID) {
    return `${version1}/customer/stores/${storeID}/review/${reviewID}?acc=${storeID}`;
  },
  STORE_REVIEW_REPLY(storeID, reviewID) {
    return `${version1}/customer/stores/${storeID}/review/${reviewID}/save`;
  },
  ASSOCIATE_REG_TOKEN: `${version1}/customer/associate-reg-token`,
  CAMPAIGNS_REGISTER_STORE(id) {
    return `${version1}/customer/campaigns/${id}/register`;
  },
  CAMPAIGNS_REGISTER_MFG(id) {
    return `${version1}/customer/manufacturers/campaigns/${id}/register`;
  },
  SIGNLE_DEAL_DETAILS(id, type) {
    return `${version1}/customer/campaigns/single-campaign?campaign-type=${type}&id=${id}`;
  },
  MY_COUPONS(params) {
    return `${version1}/customer/my-coupons?${params}`;
  },
  UPDATE_LOGIN_TIME: `${version1}/customer/login-info/update`,
  STORE_CONFIGURATION: `${version1}/customer/auth/store-configuration`,
  VERIFY_CUSTOMER(id) {
    return `${version1}/customer/auth/verify-customer/${id}`;
  },
  NEW_REGISTER_FROM_IDENTITY: `${version1}/customer/auth/create-from-identity`,
  STORE_OFFER_LOYALTY_OFFERS(id) {
    return `${version1}/customer/stores/${id}/loyalty-offers`;
  },
  SETHOMESTORE(storeId, locationId) {
    return `${version1}/customer/stores/${storeId}/locations/${locationId}/set-home-store?acc=${storeId}`;
  },
  EMAIL_PREFERENCES(email) {
    return `${version1}/customer/auth/email-preferences?email=${email}`;
  },
  UNSUBSCRIBE: `${version1}/customer/auth/unsubscribe`,
  APP_VERSION: `${version1}/customer/auth/app-version`,
  ALTRIA_EAIV_STATUS: `${version1}/customer/stores/altria-eaiv-status`,
  RESUBMIT_ALTRIA_STATUS: `${version1}/customer/stores/resubmit-altria-status`,
  EAIV_SUPPORT_STATUS: `${version1}/customer/stores/eaiv-support-status`,
  COUPON_DETAILS(coupon_id) {
    return `${version1}/customer/coupon-details/${coupon_id}`;
  },
  RJR_DEALS(id) {
    return `${version1}/customer/stores/${id}/rjr-deals`;
  },
  RJR_DEALS_DETAILS(storeId, dealId) {
    return `${version1}/customer/stores/${storeId}/rjr-deals/${dealId}`;
  },
  CAMPAIGNS_DEAL_GROUPS: `${version1}/customer/campaign-groups`,
  DISCOUNTS_DEALS: `${version1}/customer/online-discounts`,
  ONLINE_DISCOUNTS_CATEGORY: `${version1}/customer/online-discounts/category`,
  CUSTOMER_COUPONS(params) {
    return `${version1}/customer/get-customer-coupons?${params}`;
  },
  ADD_CUSTOMER_COUPON: `${version1}/customer/add-customer-coupon`,
  MOBILE_COUPON: `${version1}/loyalty/mobile-coupons`,
  KLAVIYO_EVENT: `${version1}/customer/add-event`,
  DASHBOARD_CAMPAIGNS(param) {
    return `${version1}/customer/campaigns/dashboard/campaigns${param}`;
  },
  PPLUS_NOTIFICATION_TRACK: `${version1}/customer/pplus/push-notification/click-track`,
  ADD_TO_CARD_DISCOUNT: `${version1}/customer/online-discounts/click-to-card-activity`,
};

export const IDENTITY_API_ENDPOINTS = {
  SIGN_UP: `${version1}/Signup`,
  AVAILABILITY: `${version1}/Signup/Availability`,
  VERIFY_OTP: `${version1}/Signup/VerifyOtp`,
  RESEND_OTP: `${version1}/Signup/ResendOtp`,
};
